<template>
  <hm-content title>
    <div class="mb30 flex flex-start">
      <div>
        <el-button type="primary" size="small" @click="wantTo" class="mr10"
          >我要充值</el-button
        >账户余额：
        <span class="primary" style="fontSize:20px;"
          >¥{{ accountBalanceMoney }}</span
        >
      </div>
    </div>
    <div class="mb20 flex flex-start"></div>
    <div class="table-panel flex flex-between">
      <div>
        <el-radio-group v-model="billType" size="small" @change="switchTab">
          <el-radio-button label="deduct">扣减流水</el-radio-button>
          <el-radio-button label="recharge">充值流水</el-radio-button>
        </el-radio-group>
      </div>
      <div>
        <el-select
          size="small"
          clearable
          v-if="billType === 'deduct'"
          placeholder="请选择佣金状态"
          v-model="tradeMode"
          class="mr10"
          filterable
        >
          <el-option label="退还" value="in"></el-option>
          <el-option label="扣减" value="out"></el-option>
        </el-select>
        <el-date-picker
          v-if="billType === 'deduct'"
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="tradeTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="请选择扣减时段"
          end-placeholder="请选择扣减时段"
        ></el-date-picker>

        <el-date-picker
          v-if="billType === 'recharge'"
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="rechargeTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="请选择充值时段"
          end-placeholder="请选择充值时段"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          v-show="billType === 'deduct'"
          @click="output('queryAllDeductList', '扣减流水')"
          :loading="isOutputing"
          >导出</el-button
        >
        <el-button
          type="success"
          size="small"
          v-show="billType === 'recharge'"
          @click="output('queryAllList', '充值流水')"
          :loading="isOutputing"
          >导出</el-button
        >
        <el-button
          type="success"
          size="small"
          @click="outputAccount()"
          :loading="isOutputing"
          >导出对账单</el-button
        >
      </div>
    </div>
    <div class="table mt10" v-if="billType === 'deduct'">
      <el-table
        :data="deDuctList"
        style="width: 100%"
        ref="table"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentDeductPage - 1) * 10 + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="佣金状态"
          prop="templateCode"
        >
          <template slot-scope="scope">
            <span class="danger" v-if="scope.row.tradeMode === 'in'">退还</span>
            <span class="success" v-else>扣减</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="会员"
          prop="idcardName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="电话"
          prop="authMobile"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="身份证号"
          prop="idcardNo"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="billSn"
          label="订单号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="订单金额"
          prop="actuallyPrice"
        >
          <template slot-scope="scope">
            <div class="primary">¥{{ scope.row.actuallyPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="commissionPrice"
          label="计算佣金"
        >
          <template slot-scope="scope">
            <div class="primary">¥{{ scope.row.commissionPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="扣减时间"
          prop="koujianTime"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.tradeMode === 'out'">
              {{ scope.row.tradeTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="金额"
          prop="tradeMoney"
        >
          <template slot-scope="scope">
            <div class="danger">¥{{ scope.row.tradeMoney }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="退还时间"
          prop="tuihuanTime"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.tradeMode === 'in'">
              {{ scope.row.tradeTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="feeMoney"
          label="平台服务费"
        >
          <template slot-scope="scope">
            <div class="danger">¥{{ scope.row.feeMoney }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="deDuctListTotal"
          @current-change="deductPaging"
          @size-change="handleDeductSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentDeductPage"
        ></el-pagination>
      </div>
    </div>
    <div class="table" v-if="billType === 'recharge'">
      <el-table
        :data="rechargeList"
        style="width: 100%"
        ref="table"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="充值方式"
          prop="templateCode"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.rechargeMode === 'online'">线上</div>
            <div v-else>线下</div>
          </template>
        </el-table-column>
        <!-- <el-table-column header-align="center" align="center" label="充值账户" prop="templateTitile"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          label="充值单号"
          prop="billSn"
        >
          <template slot-scope="scope">
            {{ scope.row.billSn }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="充值时间"
          prop="tradeTime"
        >
          <template slot-scope="scope">
            {{ scope.row.tradeTime }}
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="tradeMoney"
          label="充值金额"
        >
          <template slot-scope="scope">
            <div class="primary">¥{{ scope.row.tradeMoney }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="rechargeListTotal"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="账户充值"
      width="60%"
      :visible.sync="dialogVisible"
    >
      <el-form
        class="priceBt"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="充值面额" prop>
          <el-radio-group v-model="ruleForm.price">
            <el-radio
              border
              class="mr10 mt10"
              :label="v.val"
              v-for="(v, i) in priceList"
              :key="i"
              >{{ v.label }}</el-radio
            >
          </el-radio-group>
          <!-- <el-button type="primary" plain size="small">5000</el-button> -->
        </el-form-item>
        <el-form-item label="充值金额" prop="price">
          <el-input
            clearable
            v-model.trim="ruleForm.price"
            size="small"
            placeholder="请输入充值金额"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm('ruleForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
      <el-dialog
        width="30%"
        title="付款码"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div class="form-tip">请使用微信或支付宝扫码支付</div>
        <div class="text-center">
          <img class="paycode" :src="payCodeUrl" alt="付款码" />
        </div>
      </el-dialog>
    </el-dialog>
  </hm-content>
</template>

<script>
import QRCode from "qrcode";
export default {
  components: {},
  data() {
    const priceFunc = function(rule, val, callback) {
      if (val < 5000) {
        return callback(new Error("充值金额不得小于5000元"));
      }
      callback();
    }.bind(this);
    return {
      innerVisible: false,
      payCodeUrl: "",
      socket: "",
      deDuctList: [],
      deDuctListTotal: 0,
      rechargeList: [],
      rechargeListTotal: 0,
      currentDeductPage: 1,
      deductPageSize: 10,
      rechargeTime: [],
      tradeMode: "",
      billType: "deduct",
      tradeTime: [],
      priceList: [
        {
          label: "5000元",
          val: 5000
        },
        {
          label: "10000元",
          val: 10000
        },
        {
          label: "15000元",
          val: 15000
        },
        {
          label: "20000元",
          val: 20000
        },
        {
          label: "25000元",
          val: 25000
        },
        {
          label: "30000元",
          val: 30000
        },
        {
          label: "50000元",
          val: 50000
        }
      ],
      currentPage: 1,
      accountBalanceMoney: 0,
      terminal_trace: "",
      pageSize: 10,
      isOutputing: false,
      searchCondition: {
        status: "hongBao"
      },
      ruleForm: {
        price: ""
      },
      rules: {
        price: [
          {
            required: true,
            message: "请输入充值金额",
            trigger: "blur"
          },
          {
            validator(rule, value, callback) {
              if (Number.isInteger(Number(value)) && Number(value) > 0) {
                callback();
              } else {
                callback(new Error("请输入大于0的正整数"));
              }
            },
            trigger: "blur"
          },
          { required: true, validator: priceFunc, trigger: "blur" }
        ]
      },
      dialogVisible: false
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.queryDeductList();
    this.queryBalance();
  },
  destroyed() {
    // 销毁监听
    if (typeof this.socket === "object") {
      this.socket.close();
    }
  },
  methods: {
    //导出
    async outputAccount() {
      let searchParam = {};
      if (this.billType === "deduct") {
        searchParam = {
          tradeTimeStart:
            this.tradeTime && this.tradeTime.length ? this.tradeTime[0] : "",
          tradeTimeEnd:
            this.tradeTime && this.tradeTime.length ? this.tradeTime[1] : ""
        };
      } else {
        searchParam = {
          tradeTimeStart:
            this.rechargeTime && this.rechargeTime.length
              ? this.rechargeTime[0]
              : "",
          tradeTimeEnd:
            this.rechargeTime && this.rechargeTime.length
              ? this.rechargeTime[1]
              : ""
        };
      }
      await this.$store.dispatch("outputAccount", searchParam);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.$refs.hmcontent.flag = false;
      }, 0);
    },
    async queryBalance() {
      const { result } = await this.$store.dispatch("queryBalance");
      this.accountBalanceMoney = result.accountBalanceMoney;
    },
    switchTab() {
      this.checkedRow = [];
      if (this.billType === "deduct") {
        this.currentDeductPage = 1;
        this.queryDeductList();
      } else {
        this.currentPage = 1;
        this.queryList();
      }
    },
    search() {
      this.currentPage = 1;
      if (this.billType === "deduct") {
        this.queryDeductList();
      } else {
        this.queryList();
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    deductPaging(page) {
      this.currentDeductPage = page;
      this.queryDeductList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    handleDeductSizeChange(size) {
      this.currentDeductPage = 1;
      this.deductPageSize = size;
      this.queryDeductList();
    },
    async queryDeductList() {
      const { result } = await this.$store.dispatch("queryDeductList", {
        tradeMode: this.tradeMode,
        tradeTimeStart:
          this.tradeTime && this.tradeTime.length ? this.tradeTime[0] : "",
        tradeTimeEnd:
          this.tradeTime && this.tradeTime.length ? this.tradeTime[1] : "",

        pageNo: this.currentDeductPage,
        pageSize: this.deductPageSize
      });
      const { records, total } = result;
      this.deDuctList = records;
      this.deDuctListTotal = total;
    },
    async queryList() {
      const { result } = await this.$store.dispatch("queryRechargeList", {
        tradeTimeStart:
          this.rechargeTime && this.rechargeTime.length
            ? this.rechargeTime[0]
            : "",
        tradeTimeEnd:
          this.rechargeTime && this.rechargeTime.length
            ? this.rechargeTime[1]
            : "",
        pageNo: this.currentPage,
        pageSize: this.pageSize
      });
      const { records, total } = result;
      this.rechargeList = records;
      this.rechargeListTotal = total;
    },
    queryAllList() {
      return this.$store.dispatch("queryRechargeList", {
        pageNo: 1,
        pageSize: 999999,
        tradeTimeStart:
          this.rechargeTime && this.rechargeTime.length
            ? this.rechargeTime[0]
            : "",
        tradeTimeEnd:
          this.rechargeTime && this.rechargeTime.length
            ? this.rechargeTime[1]
            : ""
      });
    },
    queryAllDeductList() {
      return this.$store.dispatch("queryDeductList", {
        tradeMode: this.tradeMode,
        pageNo: 1,
        pageSize: 999999,
        tradeTimeStart:
          this.tradeTime && this.tradeTime.length ? this.tradeTime[0] : "",
        tradeTimeEnd:
          this.tradeTime && this.tradeTime.length ? this.tradeTime[1] : ""
      });
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this[funcName]()
          .then(res => {
            const list = res.result.records;
            if (funcName === "queryAllDeductList") {
              list.forEach(v => {
                if (v.tradeMode === "out") {
                  v.koujianTime = v.tradeTime;
                  v.templateCode = "扣减";
                }
                if (v.tradeMode === "in") {
                  v.tuihuanTime = v.tradeTime;
                  v.templateCode = "退还";
                }
              });
            } else {
              list.forEach(v => {
                if (v.rechargeMode === "online") {
                  v.templateCode = "线上";
                } else {
                  v.templateCode = "线下";
                }
              });
            }
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(tHeader, data, title);
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },

    pass(row) {},
    reject(row) {},
    async confirm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        const { result } = await this.$store.dispatch("toRecharge", {
          rechargeMoney: this.ruleForm.price
        });
        QRCode.toDataURL(result.message.qr_url)
          .then(payCodeUrl => {
            this.payCodeUrl = payCodeUrl;
            this.innerVisible = true;
            this.terminal_trace = result.message.terminal_trace;
            this.init();
          })
          .catch(err => {
            throw new Error(err);
          });
      }
    },
    wantTo() {
      this.dialogVisible = true;
    },
    init() {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持socket");
      } else {
        // 实例化socket
        this.socket = new WebSocket(this.$wsAddress);
        // 监听socket连接
        this.socket.onopen = this.open;
        // 监听socket错误信息
        this.socket.onerror = this.error;
        // 监听socket消息
        this.socket.onmessage = this.getMessage;
      }
    },
    open() {},
    error() {},
    getMessage(msg) {
      const originData = msg.data;
      if (originData) {
        const { code, data } = JSON.parse(originData);
        if (code === "0") {
          if (data === this.terminal_trace) {
            this.reset();
            this.socket.close();
          }
        }
      }
    },
    send() {},
    reset() {
      this.billType = "recharge";
      this.switchTab();
      this.queryBalance();
      this.dialogVisible = false;
      this.innerVisible = false;
      this.$message({
        message: "充值成功",
        type: "success"
      });
    }
  }
};
</script>
<style lang="scss">
.priceBt {
  .el-radio__input {
    display: none;
  }
}

.paycode {
  width: 240px;
}
</style>
